const lazyKeyMetrics = () => import(/* webpackChunkName: "KeyMetrics" */ './index')

export default lazyKeyMetrics
